import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// ==================================================
// TRANSLATIONS
// ==================================================

const resources = {
  // ==================================================
  // ENGLISH
  // ==================================================

  en: {
    translation: {
      // ==================================================
      // NAVBAR
      // ==================================================

      nav: {
        home: "Home",
        about: "About",
        photography: "Photography",
        rental: "Rental",
        contact: "Contact",

        // Photography
        weddings: "Weddings",
        islamicWeddings: "Islamic Weddings",
        engagements: "Engagements",
        bridalSessions: "Bridal Sessions",
        womenEvents: "Women Events",
        familyFriends: "Family & Friends",

        // Rental
        bridalRobes: "Bridal Robes",
        bridesmaids: "Bridesmaids Robes",
        accessories: "Accessories",
      },

      // ==================================================
      // HERO
      // ==================================================

      hero: {
        smallTitle: "WEDDING & PORTRAIT PHOTOGRAPHY",

        title1: "Women",
        title2: "Photographer",

        description:
          "Capturing emotions, beauty and unforgettable moments with elegance and passion.",

        works: "View The Works",

        follow: "Follow Us",

        scroll: "SCROLL TO EXPLORE",
      },

      // ==================================================
      // ABOUT
      // ==================================================

      about: {
        label: "ABOUT ME",

        title1: "Capturing",
        title2: "your story.",

        text1:
          "I am Omaya Eid, a photographer specialized in documenting weddings and special occasions. I believe that every bride has a story that deserves to be told through its most beautiful details.",

        text2:
          "I capture moments naturally and calmly, with special attention to the bride's emotions, smile, and the details of her unforgettable day.",

        text3:
          "I provide photography and videography services through a complete women-only team, with full respect for the privacy of every occasion and the bride's comfort.",

        text4:
          "My goal is to turn every photograph into a living memory that tells the story of your day and stays with you for years to come.",

        button: "More About Me",
      },

      // ==================================================
      // SERVICES
      // ==================================================

      services: {
        label: "SERVICES",

        title1: "Creating",
        title2: "memories that last.",

        photography: "Photography",

        photographyText:
          "Wedding, bridal and event photography captured with elegance and emotion.",

        rental: "Rental",

        rentalText:
          "Beautiful bridal robes, bridesmaids robes and accessories for your special moments.",
      },

      // ==================================================
      // PHOTOGRAPHY
      // ==================================================

      photography: {
        label: "PHOTOGRAPHY",

        title1: "Explore Our",
        title2: "Collections",

        categories: {
          weddings: {
            name: "Weddings",
            text: "Beautiful moments, timeless memories.",
          },

          islamicWeddings: {
            name: "Islamic Weddings",
            text: "Elegant celebrations filled with love and tradition.",
          },

          engagements: {
            name: "Engagements",
            text: "Celebrate the beginning of forever.",
          },

          bridalSessions: {
            name: "Bridal Sessions",
            text: "Elegant portraits made for your story.",
          },

          womenEvents: {
            name: "Women Events",
            text: "Capturing beautiful moments together.",
          },

          familyFriends: {
            name: "Family & Friends",
            text: "Every celebration deserves to be remembered.",
          },
        },
      },

      // ==================================================
      // RENTAL
      // ==================================================

      rental: {
        label: "RENTAL",

        title1: "Explore Our",
        title2: "Rental Collection",

        categories: {
          bridalRobes: {
            name: "Bridal Robes",
            text: "Elegant robes designed for your special moments.",
          },

          bridesmaids: {
            name: "Bridesmaids Robes",
            text: "Beautiful styles for the girls by your side.",
          },

          accessories: {
            name: "Accessories",
            text: "Elegant accessories to complete your special look.",
          },
        },
      },

      // ==================================================
      // CATEGORY GALLERY
      // ==================================================

      categoryGallery: {
        loading: "Loading gallery...",

        noGalleries: "No galleries yet",

        waiting:
          "This collection is waiting for its first story.",

        back: "Back",

        viewGallery: "View Gallery",

        untitled: "Untitled Collection",

        photograph: "Photograph",

        photographs: "Photographs",
      },

      // ==================================================
      // CATEGORY
      // ==================================================

      category: {
        photographyTitle:
          "Stories captured through the lens.",

        rentalTitle:
          "Elegant details for your special moments.",
      },

      // ==================================================
      // GALLERY DETAILS
      // ==================================================

      gallery: {
        back: "Back to",

        loading: "Loading gallery...",

        notFound: "Gallery Not Found",

        backToGallery: "Back to Gallery",

        noPhotos: "No photographs available.",

        bookNow: "Book Your Moments",

        youMayAlsoLike: "YOU MAY ALSO LIKE",

        more: "More",

        viewGallery: "View Gallery",

        image: "Image",

        photograph: "Photograph",

        photographs: "Photographs",

        of: "of",

        previous: "Previous photo",

        next: "Next photo",
      },

      // ==================================================
      // CONTACT
      // ==================================================

      contact: {
        label: "CONTACT",

        title1: "Let's",
        title2: "Connect.",

        description:
          "Tell us about your special occasion and let us help you create beautiful memories.",

        formLabel: "GET IN TOUCH",

        formTitle:
          "Tell us about your occasion.",

        name: "Name",

        namePlaceholder:
          "Your full name",

        phone: "Phone",

        phonePlaceholder:
          "Your phone number",

        occasion: "Type of Occasion",

        occasionPlaceholder:
          "Select your occasion",

        date: "Date",

        time: "Time",

        message: "Message",

        messagePlaceholder:
          "Tell us anything you'd like us to know...",

        submit: "Submit Request",

        success:
          "Your request has been prepared. We will get back to you soon.",
      },

      // ==================================================
      // FOOTER
      // ==================================================

      footer: {
        eyebrow:
          "WEDDING & PORTRAIT PHOTOGRAPHY",

        title1: "Every moment",

        title2:
          "deserves to be remembered.",

        intro:
          "Beautiful stories, genuine emotions, and unforgettable moments captured with elegance.",

        bookNow:
          "BOOK YOUR MOMENT",

        description:
          "Capturing emotions, beauty and unforgettable moments with elegance and passion.",

        explore: "EXPLORE",

        home: "Home",

        about: "About",

        photography: "Photography",

        rental: "Rental",

        contact: "Contact",

        photographyCollections:
          "PHOTOGRAPHY",

        weddings: "Weddings",

        engagements: "Engagements",

        bridalSessions:
          "Bridal Sessions",

        womenEvents:
          "Women Events",

        familyFriends:
          "Family & Friends",

        rentalCollections:
          "RENTAL",

        bridalRobes:
          "Bridal Robes",

        bridesmaids:
          "Bridesmaids Robes",

        accessories:
          "Accessories",

        contactLabel:
          "CONTACT",

        socialLabel:
          "FOLLOW",

        whatsapp:
          "WhatsApp",

        instagram:
          "Instagram",

        sendRequest:
          "Submit a Request",

        rights:
          "All rights reserved.",

        madeWith:
          "Made with",

        forBeautifulMoments:
          "for beautiful moments.",
      },
    },
  },

  // ==================================================
  // ARABIC
  // ==================================================

  ar: {
    translation: {
      // ==================================================
      // NAVBAR
      // ==================================================

      nav: {
        home: "الرئيسية",

        about: "من أنا",

        photography: "التصوير",

        rental: "التأجير",

        contact: "تواصل معنا",

        // Photography
        weddings: "الأعراس",

        islamicWeddings:
          "الأعراس الإسلامية",

        engagements: "الخطوبات",

        bridalSessions:
          "جلسات العروس",

        womenEvents:
          "المناسبات النسائية",

        familyFriends:
          "العائلة والأصدقاء",

        // Rental
        bridalRobes:
          "أرواب العروس",

        bridesmaids:
          "أرواب وصيفات العروس",

        accessories:
          "الإكسسوارات",
      },

      // ==================================================
      // HERO
      // ==================================================

      hero: {
        smallTitle:
          "تصوير الأعراس والبورتريه",

        title1: "مصوّرة",

        title2: "نسائية",

        description:
          "أوثّق المشاعر والجمال واللحظات التي لا تُنسى بكل أناقة وشغف.",

        works:
          "شاهدي أعمالي",

        follow:
          "تابعيني",

        scroll:
          "اكتشفي المزيد",
      },

      // ==================================================
      // ABOUT
      // ==================================================

      about: {
        label: "عنّي",

        title1: "أوثّق",

        title2: "قصتكِ.",

        text1:
          "أنا أمية عيد، مصوّرة متخصصة في توثيق لحظات الأعراس والمناسبات الخاصة، حيث أؤمن أن لكل عروس قصة تستحق أن تُروى بأجمل تفاصيلها.",

        text2:
          "ألتقط اللحظات بعفوية وهدوء، مع تركيز خاص على مشاعر العروس، ابتسامتها، وتفاصيل يومها الذي لا يتكرر.",

        text3:
          "أقدّم خدمات التصوير الفوتوغرافي والفيديو ضمن فريق نسائي متكامل، مع احترام كامل لخصوصية كل مناسبة وراحة العروس.",

        text4:
          "هدفي أن تتحول كل صورة إلى ذكرى حيّة، تحكي قصة يومكِ وتبقى معكِ بكل إحساسها لسنوات طويلة.",

        button:
          "المزيد عنّي",
      },

      // ==================================================
      // SERVICES
      // ==================================================

      services: {
        label: "خدماتنا",

        title1: "نصنع",

        title2:
          "ذكريات تدوم.",

        photography:
          "التصوير",

        photographyText:
          "تصوير الأعراس والعروس والمناسبات بأسلوب أنيق مليء بالمشاعر.",

        rental:
          "التأجير",

        rentalText:
          "أرواب العروس، أرواب وصيفات العروس والإكسسوارات للحظاتكِ المميزة.",
      },

      // ==================================================
      // PHOTOGRAPHY
      // ==================================================

      photography: {
        label: "التصوير",

        title1: "اكتشفي",

        title2:
          "مجموعاتنا",

        categories: {
          weddings: {
            name: "الأعراس",

            text:
              "لحظات جميلة وذكريات خالدة.",
          },

          islamicWeddings: {
            name:
              "الأعراس الإسلامية",

            text:
              "احتفالات أنيقة تجمع بين الحب والتقاليد.",
          },

          engagements: {
            name: "الخطوبات",

            text:
              "احتفلي ببداية حكاية العمر.",
          },

          bridalSessions: {
            name:
              "جلسات العروس",

            text:
              "صور أنيقة تروي قصتكِ بكل جمال.",
          },

          womenEvents: {
            name:
              "المناسبات النسائية",

            text:
              "نوثّق أجمل اللحظات التي تجمعكنّ.",
          },

          familyFriends: {
            name:
              "العائلة والأصدقاء",

            text:
              "كل مناسبة تستحق أن تبقى ذكرى جميلة.",
          },
        },
      },

      // ==================================================
      // RENTAL
      // ==================================================

      rental: {
        label: "التأجير",

        title1: "اكتشفي",

        title2:
          "مجموعة التأجير",

        categories: {
          bridalRobes: {
            name:
              "أرواب العروس",

            text:
              "أرواب أنيقة مصممة للحظاتكِ المميزة.",
          },

          bridesmaids: {
            name:
              "أرواب وصيفات العروس",

            text:
              "إطلالات جميلة للفتيات اللواتي يشاركنكِ يومكِ.",
          },

          accessories: {
            name:
              "الإكسسوارات",

            text:
              "إكسسوارات أنيقة تكمل إطلالتكِ المميزة.",
          },
        },
      },

      // ==================================================
      // CATEGORY GALLERY
      // ==================================================

      categoryGallery: {
        loading:
          "جاري تحميل المعرض...",

        noGalleries:
          "لا توجد ألبومات بعد",

        waiting:
          "هذه المجموعة بانتظار قصتها الأولى.",

        back:
          "العودة",

        viewGallery:
          "مشاهدة الألبوم",

        untitled:
          "مجموعة بدون عنوان",

        photograph:
          "صورة",

        photographs:
          "صور",
      },

      // ==================================================
      // CATEGORY
      // ==================================================

      category: {
        photographyTitle:
          "قصص نوثّقها بعدسة مختلفة.",

        rentalTitle:
          "تفاصيل أنيقة للحظاتكِ المميزة.",
      },

      // ==================================================
      // GALLERY DETAILS
      // ==================================================

      gallery: {
        back:
          "العودة إلى",

        loading:
          "جاري تحميل الصور...",

        notFound:
          "الألبوم غير موجود",

        backToGallery:
          "العودة إلى المعرض",

        noPhotos:
          "لا توجد صور متاحة حالياً.",

        bookNow:
          "احجزي لحظاتكِ",

        youMayAlsoLike:
          "قد يعجبكِ أيضاً",

        more:
          "المزيد من",

        viewGallery:
          "مشاهدة الألبوم",

        image:
          "صورة",

        photograph:
          "صورة",

        photographs:
          "صور",

        of:
          "من",

        previous:
          "الصورة السابقة",

        next:
          "الصورة التالية",
      },

      // ==================================================
      // CONTACT
      // ==================================================

      contact: {
        label:
          "تواصل معنا",

        title1:
          "لنصنع",

        title2:
          "ذكرياتكِ.",

        description:
          "أخبرينا عن مناسبتكِ الخاصة ودعينا نساعدكِ في توثيق أجمل لحظاتكِ.",

        formLabel:
          "تواصلي معنا",

        formTitle:
          "أخبرينا عن مناسبتكِ.",

        name:
          "الاسم",

        namePlaceholder:
          "أدخلي اسمكِ الكامل",

        phone:
          "رقم الهاتف",

        phonePlaceholder:
          "أدخلي رقم هاتفكِ",

        occasion:
          "نوع المناسبة",

        occasionPlaceholder:
          "اختاري نوع المناسبة",

        date:
          "التاريخ",

        time:
          "الوقت",

        message:
          "الرسالة",

        messagePlaceholder:
          "أخبرينا بأي تفاصيل ترغبين بإضافتها...",

        submit:
          "إرسال الطلب",

        success:
          "تم تجهيز طلبكِ، وسنتواصل معكِ قريباً.",
      },

      // ==================================================
      // FOOTER
      // ==================================================

      footer: {
        eyebrow:
          "تصوير الأعراس والبورتريه",

        title1:
          "كل لحظة",

        title2:
          "تستحق أن تبقى ذكرى.",

        intro:
          "حكايات جميلة، مشاعر صادقة، ولحظات لا تُنسى نوثّقها بكل أناقة.",

        bookNow:
          "احجزي لحظتكِ",

        description:
          "أوثّق المشاعر والجمال واللحظات التي لا تُنسى بكل أناقة وشغف.",

        explore:
          "اكتشفي",

        home:
          "الرئيسية",

        about:
          "من أنا",

        photography:
          "التصوير",

        rental:
          "التأجير",

        contact:
          "تواصل معنا",

        photographyCollections:
          "التصوير",

        weddings:
          "الأعراس",

        engagements:
          "الخطوبات",

        bridalSessions:
          "جلسات العروس",

        womenEvents:
          "المناسبات النسائية",

        familyFriends:
          "العائلة والأصدقاء",

        rentalCollections:
          "التأجير",

        bridalRobes:
          "أرواب العروس",

        bridesmaids:
          "أرواب وصيفات العروس",

        accessories:
          "الإكسسوارات",

        contactLabel:
          "للتواصل",

        socialLabel:
          "تابعينا",

        whatsapp:
          "واتساب",

        instagram:
          "إنستغرام",

        sendRequest:
          "إرسال طلب",

        rights:
          "جميع الحقوق محفوظة.",

        madeWith:
          "صُنع بحب",

        forBeautifulMoments:
          "للحظات الجميلة.",
      },
    },
  },
};

// ==================================================
// INITIAL LANGUAGE
// ==================================================

const savedLanguage =
  localStorage.getItem("language") || "en";

document.documentElement.dir =
  savedLanguage === "ar" ? "rtl" : "ltr";

document.documentElement.lang =
  savedLanguage;

// ==================================================
// INITIALIZE I18N
// ==================================================

i18n
  .use(initReactI18next)
  .init({
    resources,

    lng: savedLanguage,

    fallbackLng: "en",

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;